<template>
  <b-modal
    :id="id"
    size="md"
    ok-only
    ok-title="Chiudi"
    ok-variant="-transparent"
    header-bg-variant="lisaweb"
    body-class="modal-fixed-height"
    no-close-on-esc
    no-close-on-backdrop
    @ok="close"
  >
    <template #modal-header="{ cancel }">
      <div slot="modal-title" class="modal-title">
        <b-icon icon="hammer"></b-icon>
        <span>Acconti - Chiusura Massiva</span>
      </div>
      <button
        type="button"
        class="close"
        title="Chiudi"
        data-dismiss="modal"
        @click="
          cancel();
          close();
        "
      >
        <base-icon name="close" width="14" height="14"/>
      </button>
    </template>
    <div class="mt-2">
      <b-overlay center :show="isLoading" rounded="sm">
        <div v-if="!isLoading">
          <validation-observer
            ref="observer1"
            v-slot="{ handleSubmit, invalid }"
          >
            <b-form @submit.prevent="">
              <b-card class="filter">
                <b-alert v-if="mode === 'all'" show variant="warning" class="mb-3">
                  <strong>ATTENZIONE: </strong>Verranno chiusi <strong>tutti i {{ total }} acconti</strong>
                  che rispettano i filtri attivi<template v-if="totalAmount"
                    >, per un totale di <strong>€ {{ totalAmount }}</strong></template
                  >. L'operazione viene eseguita in background.
                </b-alert>
                <b-row>
                  <div class="col-md-6">
                    <base-datepicker
                      vid="book_date"
                      name="Data Registrazione"
                      label="Data Registrazione"
                      v-model="form.book_date"
                      :rules="{ required: true }"
                    />
                  </div>
                  <div class="col-md-6">
                    <base-select
                      name="Forme di Pagamento"
                      vid="treasury_id"
                      label="Forme di Pagamento"
                      v-model="form.treasury_id"
                      :options="opt_treasuries"
                      :rules="{ required: true }"
                    />
                  </div>
                </b-row>
                <b-row v-if="mode !== 'all'">
                  <div class="col-md-6">
                    <base-currency
                      v-if="inputVal"
                      name="total_mass_deferred"
                      vid="total_mass_deferred"
                      label="Importo Totale"
                      v-model="inputVal"
                      :options="{
                        currency: 'EUR',
                        locale: 'it-IT',
                        precision: 2,
                      }"
                      readonly
                    />
                    <base-currency
                      v-if="inputDeposited"
                      name="total_mass_deposited"
                      vid="total_mass_deposited"
                      label="Importo Totale"
                      v-model="inputDeposited"
                      :options="{
                        currency: 'EUR',
                        locale: 'it-IT',
                        precision: 2,
                      }"
                      readonly
                    />
                  </div>
                </b-row>
              </b-card>
              <b-button
                @click="handleSubmit(save)"
                type="button"
                :disabled="invalid"
                variant="lisaweb"
                size="sm"
                class="mt-2 mb-4 float-right"
              >
                Salva
              </b-button>
            </b-form>
          </validation-observer>
        </div>
        <template #overlay>
          <div class="text-center">
            <base-icon name="loading" width="35" height="35"/>
            <p id="cancel-label">Operazione in corso...</p>
          </div>
        </template>
      </b-overlay>
    </div>
  </b-modal>
</template>
<script>
import BaseIcon from "@/components/BaseIcon";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import BaseSelect from "@/components/form/BaseSelect";
import BaseCurrency from "@/components/form/BaseCurrency";
import {mapGetters} from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      opt_treasuries: [],
      isLoading: false,
      form: {
        treasury_id: null,
        book_date: moment().format("YYYY-MM-DD"),
      },
    };
  },
  props: {
    id: {
      type: String,
      default: "massReducedModal",
    },
    grandtotaldeferred: {
      type: Number,
      default: 0,
    },
    grandtotaldeposited: {
      type: Number,
      default: 0,
    },
    mode: {
      type: String,
      default: "selection",
    },
    total: {
      type: Number,
      default: 0,
    },
    totalAmount: {
      type: String,
      default: null,
    },
  },
  components: {
    BaseIcon,
    BaseDatepicker,
    BaseSelect,
    BaseCurrency,
  },
  methods: {
    save() {
      this.isLoading = true;
      this.$emit("save", this.form);
    },
    close() {
      this.form.treasury_id = null;
      this.form.book_date = moment().format("YYYY-MM-DD");
    },
    ...mapGetters("auth", {
      getAllTreasuries: "allTreasuries",
    }),
  },
  computed: {
    inputVal: {
      get() {
        return this.grandtotaldeferred;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    inputDeposited: {
      get() {
        return this.grandtotaldeposited;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  mounted() {
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      if (modalId !== this.id) return;
      this.form.treasury_id = null;
      this.isLoading = false;
    });
    this.opt_treasuries = this.getAllTreasuries().filter(
      (e) => e.sector.is_system.value === "N" && e.sector.is_agency.value == "N"
    );
    let found = this.getAllTreasuries().find((e) => e.code === "AB");
    if (found) {
      this.opt_treasuries.push(found);
    }
  },
};
</script>

<style lang="scss" scoped>
:deep(.table-responsive, .b-table-sticky-header) {
  overflow-y: visible;
}
:deep(.modal-fixed-height) {
  height: 400px !important;
  overflow-y: auto;
}
:deep(.modal-body:has(.multiselect--active)) {
  min-height: 450px;
}
</style>